var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('base-button',{staticStyle:{"white-space":"normal","margin":"2px"},attrs:{"size":"sm","type":"warning"},on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t("logout")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }